import React, { useState, useEffect, useCallback } from 'react';
import Header from './Header';
import dayjs from 'dayjs';
import API_URL from '../config';

const tipos = [
  { value: '', label: 'Todos' },
  { value: 1, label: 'Crédito à Vista' },
  { value: 2, label: 'Crédito Parcelado' },
  { value: 3, label: 'Crédito Parcelado Emissor' },
  { value: 4, label: 'Débito' },
  { value: 6, label: 'Pix' },
  { value: 10, label: 'Vale Alimentação' },
  { value: 11, label: 'Vale Refeição' },
  { value: 12, label: 'Vale Presente' },
  { value: 13, label: 'Vale Combustível' },
  { value: 50, label: 'ConexãoPIX' },
];
const statusList = [
  { value: '', label: 'Todos' },
  { value: 0, label: 'Aberto' },
  { value: 1, label: 'Autorizado' },
  { value: 2, label: 'Falha' },
  { value: 3, label: 'Negado' },
  { value: 4, label: 'Cancelado' },
  { value: 5, label: 'Arquivado' },
  { value: 6, label: 'Estornado' },
  { value: 9, label: 'Em Processamento' },
  { value: 51, label: 'Cancelamento Solicitado' },
];

function RevendaConsultasMobtefPage({ usuario, empresaSelecionada, handleVoltar, handleSair }) {
  const [empresas, setEmpresas] = useState([]);
  const [empresaId, setEmpresaId] = useState('');
  const [filtros, setFiltros] = useState({
    emissaoIni: dayjs().format('YYYY-MM-DD'),
    emissaoFim: dayjs().format('YYYY-MM-DD'),
    tipo: '',
    status: '',
  });
  const [dados, setDados] = useState([]);
  const [carregando, setCarregando] = useState(false);

  const fetchEmpresas = useCallback(async () => {
    try {
      const res = await fetch(`${API_URL}/pessoas?revenda_id=${empresaSelecionada.id}&todas=true`);
      const data = await res.json();
      setEmpresas(Array.isArray(data) ? data : []);
    } catch {
      setEmpresas([]);
    }
  }, [empresaSelecionada.id]);

  useEffect(() => {
    if (empresaSelecionada?.id) {
      fetchEmpresas();
    }
  }, [empresaSelecionada, fetchEmpresas]);

  const handleChange = e => {
    setFiltros({ ...filtros, [e.target.name]: e.target.value });
  };

  const pesquisar = async () => {
    setCarregando(true);
    if (empresaId) {
      let url = `${API_URL}/tef/relatorio?empresa_id=${empresaId}`;
      if (filtros.emissaoIni) url += `&data_ini=${filtros.emissaoIni}`;
      if (filtros.emissaoFim) url += `&data_fim=${filtros.emissaoFim}`;
      if (filtros.tipo) url += `&tipo=${filtros.tipo}`;
      if (filtros.status) url += `&status=${filtros.status}`;
      const resp = await fetch(url);
      const data = await resp.json();
      setDados(Array.isArray(data) ? data : []);
      setCarregando(false);
    } else {
      const promises = empresas.map(async emp => {
        let url = `${API_URL}/tef/relatorio?empresa_id=${emp.id}`;
        if (filtros.emissaoIni) url += `&data_ini=${filtros.emissaoIni}`;
        if (filtros.emissaoFim) url += `&data_fim=${filtros.emissaoFim}`;
        if (filtros.tipo) url += `&tipo=${filtros.tipo}`;
        if (filtros.status) url += `&status=${filtros.status}`;
        const resp = await fetch(url);
        const data = await resp.json();
        return { empresa_id: emp.id, dados: Array.isArray(data) ? data : [] };
      });
      const results = await Promise.all(promises);
      const dadosAll = results.flatMap(r => r.dados.map(l => ({ ...l, empresa_id: r.empresa_id })));
      setDados(dadosAll);
      setCarregando(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-blue-300">
      <Header usuario={usuario} empresa={empresaSelecionada} onVoltar={handleVoltar} onSair={handleSair} />
      <div className="flex flex-col items-center justify-center mt-8">
        <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-5xl border border-blue-100 flex flex-col items-center">
          <h2 className="text-2xl font-bold text-blue-700 mb-4">Consultas MobTEF</h2>
          {/* Filtros em card */}
          <div className="w-full bg-blue-50 rounded-lg p-4 mb-6 border flex flex-wrap gap-4 items-end">
            <div>
              <label className="block text-xs font-semibold text-gray-600">Empresa</label>
              <select name="empresaId" value={empresaId} onChange={e => setEmpresaId(e.target.value)} className="border rounded px-2 py-1 min-w-[180px]">
                <option value="">Selecione</option>
                {empresas.map(emp => (
                  <option key={emp.id} value={emp.id}>{emp.fantasia}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-600">Emissão Inicial</label>
              <input type="date" name="emissaoIni" value={filtros.emissaoIni} onChange={handleChange} className="border rounded px-2 py-1" />
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-600">Emissão Final</label>
              <input type="date" name="emissaoFim" value={filtros.emissaoFim} onChange={handleChange} className="border rounded px-2 py-1" />
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-600">Tipo</label>
              <select name="tipo" value={filtros.tipo} onChange={handleChange} className="border rounded px-2 py-1">
                {tipos.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
              </select>
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-600">Status</label>
              <select name="status" value={filtros.status} onChange={handleChange} className="border rounded px-2 py-1">
                {statusList.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
              </select>
            </div>
            <button onClick={pesquisar} className="bg-blue-600 text-white px-4 py-2 rounded font-semibold hover:bg-blue-700 transition">Pesquisar</button>
          </div>
          {/* Resumo sintético por empresa */}
          <div className="w-full mb-6">
            <div className="bg-blue-50 rounded-lg p-4 border flex flex-wrap gap-4">
              {empresaId
                ? (() => {
                    const empresa = empresas.find(e => String(e.id) === String(empresaId));
                    const dadosEmpresa = dados;
                    const totalVendas = dadosEmpresa.length;
                    const valorTotal = dadosEmpresa.reduce((acc, l) => acc + Number(l.valor), 0);
                    return (
                      <div className="bg-white rounded px-4 py-2 shadow text-sm text-gray-700 border flex flex-col items-center min-w-[200px]">
                        <span className="font-bold text-blue-700 mb-1">{empresa?.fantasia || 'Empresa'}</span>
                        <span className="text-xs text-gray-500 mb-1">ID: {empresa?.id}</span>
                        <span className="text-lg font-bold text-blue-800">{totalVendas} vendas</span>
                        <span className="text-blue-700 font-bold text-xl">R$ {valorTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                      </div>
                    );
                  })()
                : empresas.map(emp => {
                    const dadosEmpresa = dados.filter(l => String(l.empresa_id) === String(emp.id));
                    const totalVendas = dadosEmpresa.length;
                    const valorTotal = dadosEmpresa.reduce((acc, l) => acc + Number(l.valor), 0);
                    return (
                      <div key={emp.id} className="bg-white rounded px-4 py-2 shadow text-sm text-gray-700 border flex flex-col items-center min-w-[200px]">
                        <span className="font-bold text-blue-700 mb-1">{emp.fantasia}</span>
                        <span className="text-xs text-gray-500 mb-1">ID: {emp.id}</span>
                        <span className="text-lg font-bold text-blue-800">{totalVendas} vendas</span>
                        <span className="text-blue-700 font-bold text-xl">R$ {valorTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                      </div>
                    );
                  })
              }
            </div>
            {carregando && (
              <div className="w-full text-center py-8 text-blue-700 font-bold">Carregando...</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default RevendaConsultasMobtefPage; 